export class RequestToJoinGroupSuccess {
  public static readonly type = '[Browse/Groups] RequestToJoinGroupSuccess';
}
